import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button.jsx';
import '../styles/DigitalInvitationFaq.css';

const faqItems = [
  {
    question: 'What is a digital invitation?',
    answer:
      'A digital invitation is an online invitation page you can share through Messenger, Facebook, email, or chat links. It is easier to update than a static image and works well for mobile guests.',
  },
  {
    question: 'How much does a digital invitation cost?',
    answer:
      'Template-based digital invitations currently start at P200 to P300, while custom digital invitation projects usually range from P350 to P700 depending on the design scope.',
  },
  {
    question: 'What is included in a template-based invitation?',
    answer:
      'A template-based invitation gives you a ready-made layout that can be personalized with your event details, theme information, and shareable invitation link.',
  },
  {
    question: 'Can I request a custom digital invitation instead of a template?',
    answer:
      'Yes. If you need a unique theme, more animation, or a layout that is not covered by the ready-made templates, you can request a custom digital invitation project.',
  },
  {
    question: 'Is RSVP included in the invitation flow?',
    answer:
      'Yes. The service is built around RSVP-ready invitation pages so guests can open the link and respond more easily than with a static file alone.',
  },
  {
    question: 'How long does delivery usually take?',
    answer:
      'Template-based digital invitations are generally faster to prepare than custom builds. Exact turnaround depends on revisions, content readiness, and the event type, but the service is positioned for fast online delivery.',
  },
];

export default function DigitalInvitationFaq() {
  return (
    <div className="digital-faq-page">
      <section className="digital-faq-hero">
        <p className="digital-faq-eyebrow">Digital invitation FAQ</p>
        <h1>Digital Invitation FAQ for Weddings, Birthdays, and Events</h1>
        <p>
          Read the most common questions about digital invitations, pricing, template options,
          custom design requests, RSVP flow, and how E-Invitation works in the Philippines.
        </p>
      </section>

      <section className="digital-faq-grid">
        {faqItems.map((item) => (
          <article key={item.question} className="digital-faq-card">
            <h2>{item.question}</h2>
            <p>{item.answer}</p>
          </article>
        ))}
      </section>

      <section className="digital-faq-cta">
        <div>
          <h2>Need a ready-made design or custom invitation?</h2>
          <p>
            Browse the template gallery first, then book the digital invitation style that fits
            your celebration and timeline.
          </p>
        </div>
        <div className="digital-faq-actions">
          <Link to="/invitations">
            <Button variant="primary" size="large">
              Browse Templates
            </Button>
          </Link>
          <Link to="/book" className="digital-faq-link">
            Start your booking
          </Link>
        </div>
      </section>
    </div>
  );
}